import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2434198e")

_pushScopeId("data-v-2434198e")
const _hoisted_1 = { class: "UserCard" }
const _hoisted_2 = { class: "UserCard__information" }
const _hoisted_3 = { class: "information__id" }
const _hoisted_4 = { class: "information__name" }
const _hoisted_5 = { class: "information__email" }
const _hoisted_6 = { class: "UserCard__actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.user.id), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.user.name), 1),
      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.user.email), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_icon_edit, {
        class: "actions__icon",
        onClick: _ctx.emitEdit
      }, null, 8, ["onClick"]),
      _createVNode(_component_icon_close, {
        class: "actions__icon",
        onClick: _ctx.emitDelete
      }, null, 8, ["onClick"])
    ])
  ]))
})